"use client";
import hljs from "highlight.js";
import "highlight.js/styles/github-dark.css";
import { useEffect, useRef, useState } from "react";

export default function CodeBlock({
  codes = {},
  defaultLang = "php",
  dropdown,
  title,
  status,
  statusText,
}) {
  const codeRef = useRef(null);
  const [language, setLanguage] = useState(defaultLang);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (codeRef.current) {
      codeRef.current.removeAttribute("data-highlighted");
      codeRef.current.className = `language-${language}`;
      hljs.highlightElement(codeRef.current);
    }
  }, [language]);

  const copyCode = () => {
    navigator.clipboard.writeText(codes[language]);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="code-editor relative border rounded-lg bg-white overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-[#F5F7F9] border-b">
        <h3 className="text-[16px] font-bold text-user-text">
          {title}{" "}
          {status && (
            <span
              className={`ms-4 h-[30px] rounded-full px-[16px] inline-flex justify-center items-center text-[14px] font-semibold border ${
                status === "success"
                  ? "text-user-success border-[rgba(20,174,111,0.20)]"
                  : "text-user-error border-[rgba(220,60,34,0.20)]"
              }`}
            >
              {statusText}
            </span>
          )}
        </h3>
        <div className="flex items-center gap-3">
          {dropdown && (
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="px-2 py-2 text-sm border rounded bg-white"
            >
              {Object.keys(codes).map((lang) => (
                <option key={lang} value={lang}>
                  {lang.toUpperCase()}
                </option>
              ))}
            </select>
          )}
          <button
            onClick={copyCode}
            className="text-xs px-4 py-2.5 rounded bg-[#30363d] hover:bg-[#3c444d] text-white"
          >
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>
      </div>

      <pre className="overflow-x-auto code-area">
        <code ref={codeRef} className={`language-${language}`}>
          {codes[language]}
        </code>
      </pre>
    </div>
  );
}
